import { useState, useEffect } from "react";
import axios from "axios";
import { Card } from "react-bootstrap";
import "./design/change_password.css";
import { useNavigate } from "react-router-dom";

const CambiarPassword = () => {
  const [form, setForm] = useState({ actual: "", nueva: "" });
  const [mensaje, setMensaje] = useState("");
  const [valida, setValida] = useState(false);
  const resetUserId = localStorage.getItem("resetUserId");
  const esReset = resetUserId && !localStorage.getItem("token");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const updatedForm = { ...form, [e.target.name]: e.target.value };
    setForm(updatedForm);

    // Validar en tiempo real
    if (e.target.name === "nueva") {
      setValida(validarPassword(e.target.value));
    }
  };

  const validarPassword = (password) => {
    const tieneMinimoCaracteres = password.length >= 6;
    const tieneLetra = /[a-zA-Z]/.test(password);
    const tieneNumero = /\d/.test(password);
    return tieneMinimoCaracteres && tieneLetra && tieneNumero;
  };


  const [confirmarNueva, setConfirmarNueva] = useState("");

  const handleConfirmarNuevaChange = (e) => {
    setConfirmarNueva(e.target.value);
  };

  useEffect(() => {
    if (form.nueva !== confirmarNueva) {
      setMensaje("Las contraseñas no coinciden");
      setValida(false);
    } else {
      setMensaje("");
      setValida(validarPassword(form.nueva));
    }
  }, [confirmarNueva, form.nueva]);

  useEffect(() => {
    if (localStorage.getItem("token")) {
      localStorage.removeItem("resetUserId");
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!valida) {
      setMensaje("La nueva contraseña no cumple con los requisitos o no coincide.");
      return;
    }

    try {
      if (esReset) {
        // 🔥 flujo de reset (sin token)
        await axios.put("https://socios.kolpingchile.cl/backend/api/cambiar-password/reset", {
          userId: Number(resetUserId),
          newPassword: form.nueva
        });
        console.log("Contraseña restablecida para usuario ID:", resetUserId);

        localStorage.removeItem("resetUserId");

      } else {
        await axios.put("https://socios.kolpingchile.cl/backend/api/cambiar-password", form, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
        );
      }
      setMensaje("Contraseña cambiada correctamente");
      setForm({ actual: "", nueva: "" });
      setConfirmarNueva("");
      setValida(false);
      if (esReset) {
        navigate("/login");
      } else {
        navigate("/inicio");
      }
    } catch (err) {
      console.error("Error backend:", err.response?.data);
      setMensaje(err.response?.data?.error || "Error al cambiar la contraseña");
    }
  };

  console.log("CambiarPassword renderizando", { resetUserId, esReset });

  return (
    <div>
      <Card className="change-password-card">
        <h3>Cambiar contraseña</h3><br />

        <form onSubmit={handleSubmit}>
          {!esReset && (
            <>
              <input
                type="password"
                name="actual"
                placeholder="Contraseña actual"
                value={form.actual}
                onChange={handleChange}
                required
              />
              <br /><br />
            </>
          )}

          <input
            type="password"
            name="nueva"
            placeholder="Nueva contraseña"
            value={form.nueva}
            onChange={handleChange}
            required
          />
          <br /><br />
          <input
            type="password"
            name="confirmarNueva"
            placeholder="Confirmar nueva contraseña"
            value={confirmarNueva}
            onChange={handleConfirmarNuevaChange}
            required
          />
          <br /><br />

          {/* <br /><br />
            <strong>* Tener al menos 6 caracteres</strong><br />
            <strong>* Incluir al menos 1 letra</strong><br />
            <strong>* Incluir al menos 1 número</strong>
            <br /><br /> */}

          {form.nueva && (
            <div style={{ color: "GrayText" }}>
              La nueva contraseña debe tener:
              <div>
                <p style={{ color: form.nueva.length >= 6 ? "green" : "red" }}>
                  {form.nueva.length >= 6 ? "✅" : "❌"} Mínimo 6 caracteres
                </p>
                <p style={{ color: /[a-zA-Z]/.test(form.nueva) ? "green" : "red" }}>
                  {/[a-zA-Z]/.test(form.nueva) ? "✅" : "❌"} Al menos 1 letra
                </p>
                <p style={{ color: /\d/.test(form.nueva) ? "green" : "red" }}>
                  {/\d/.test(form.nueva) ? "✅" : "❌"} Al menos 1 número
                </p>
              </div>
            </div>
          )}

          {mensaje && <p style={{ color: "red", fontWeight: "bold" }}>{mensaje}</p>}

          <button type="submit" disabled={!valida}>Cambiar contraseña</button>
        </form>
      </Card>
    </div>
  );
};

export default CambiarPassword;
